<template>

    <v-panel title="Code">
        <v-section-code expanded />
        <v-section-block />
    </v-panel>

</template>

<script>

import Panel from './Panel';
import SectionBlock from './sections/SectionBlock';
import SectionCode from './sections/SectionCode';

export default {

    components: {
        'v-panel': Panel,
        'v-section-block': SectionBlock,
        'v-section-code': SectionCode,
    },

}

</script>